import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Images } from "lucide-react";
import { api } from "@/lib/api";
import { MARKET_LABEL, SCAN_MARKETS } from "../valueFormat";

export function ManagerLink({ day, refresh }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/value/manager", { params: { day } }).then((r) => setD(r.data)).catch(() => {}); }, [day, refresh]);
  const active = (d?.lines || []).filter((l) => !l.result);
  return (
    <Link to={`/odds-manager?day=${day}`} className="vs-mgr" data-testid="value-manager-link">
      <Images size={20} />
      <div>
        <b>Odds Upload Manager</b>
        <span data-testid="value-manager-summary">{d ? `${d.screenshots.length} screenshots · ${active.length} active prices` : "Loading…"}</span>
        <small>{SCAN_MARKETS.map((m) => `${MARKET_LABEL[m]} ${d ? d.screenshots.filter((s) => (s.markets || []).includes(m)).length : 0}`).join(" · ")}</small>
      </div>
      <ArrowRight size={16} />
    </Link>
  );
}
